import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { interval, Subscription } from 'rxjs';
import { NbToastrService } from '@nebular/theme';
import { environment } from '../../../environments/environment';
import { ViewChildren, QueryList } from '@angular/core';
import { AgmInfoWindow } from '@agm/core';


@Component({
  selector: 'ngx-map-view-component',
  templateUrl: './map-view-component.component.html',
  styleUrls: ['./map-view-component.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class MapViewComponentComponent implements OnInit {
  vehicles: any[] = [];
  selectedVehicle: any = null;
  searchText = '';
  mobileNumber !: string;
  isSidebarOpen = true;

  // map defaults
  lat = 21.2514;
  lng = 81.6296;
  zoom = 7;
  mapType: any;
  loading = false;

  // counters
  runningCount = 0;
  idleCount = 0;
  stoppedCount = 0;
  inactiveCount = 0;
  noDataCount = 0;
  totalCount = 0;

  refreshSub!: Subscription;
  vehicleData: any = [];
  mapInstance!: google.maps.Map;
  vehicleSpeedData: any = [];
  last_trip_summary: any = '';
  mmu_summary: any = '';
  displayVehicles: any[] = [];
  @ViewChildren(AgmInfoWindow) infoWindows!: QueryList<AgmInfoWindow>;
  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.mobileNumber = params['mobile'];
      if (this.mobileNumber) {
        this.loadVehicles(this.mobileNumber);
      } else {
        this.loadVehicles(localStorage.getItem('MOBILE'));
      }
    });
    this.refreshSub = interval(60000).subscribe(() => {
      this.loadVehicles(this.mobileNumber);
    });
  }
  onMapReady(map: google.maps.Map) {
    this.mapInstance = map;
  }
  reFreshVehicles() {
    this.loadVehicles(localStorage.getItem('MOBILE'));
  }

  loadVehicles(mobile: any) {
    // this.loading = true;
    const url = `${environment.apiBaseUrl}home_v2_public?mobile=${mobile}&X-Api-Key=FEA3E5D0QFCEBFD54F0A6A674ECAE3F8&user_type=Customer&device_token=Web`;

    this.http.get<any>(url).subscribe(res => {
      if (res.status && res.data.length > 0) {
        this.vehicleData = res.total_vehicles;
        this.vehicles = res.data.map((v: any) => {
          let icon = 'assets/images/all_images/table/yellow/Car.png'; // idle
          if (v.vehicle_motion_status_color === '#62760c') {
            icon = 'assets/images/all_images/table/green/Car.png'; // running
          } else if (v.vehicle_motion_status_color === '#ec0101') {
            icon = 'assets/images/all_images/table/red/Car.png'; // stopped
          }

          return {
            id: v.device_id,
            vehicle_number: v.vehicle_number,
            vehicle_type: v.vehicle_type,
            lat: parseFloat(v.latitude),
            lng: parseFloat(v.longitude),
            speed: v.speed,
            landmark: v.landmark,
            servertime: v.servertime,
            ignition: v.ignition,
            day_distance: v.day_distance,
            travel_duration: v.travel_duration,
            max_speed: v.max_speed,
            avg_speed: v.avg_speed,
            alert_count: v.alert_count,
            parking_duration: v.parking_duration,
            power_status: v.power_status,
            driver_name: v.driver_name,
            customer_name: v.customer_name,
            last_city: v.last_city,
            color: v.vehicle_motion_status_color,
            icon: icon,
            last_running_time: v.last_running_time,
            device_link_id: v.device_link_id,
            total_distance: v.total_distance,
            batteryLevel: v.batteryLevel,
            last_location: v.last_location,
            gps_lock_status: v.gps_lock_status,
            driver_mobile: v.driver_mobile,
            mmu_summary: v.mmu_summary,
            last_trip_summary: v.last_trip_summary,
            org_id: v.org_id,
            vehicle_name: v?.vehicle_name

          };
        });
        this.displayVehicles = [...this.vehicles];


        // counters
        this.runningCount = this.vehicles.filter(v => v.color === '#62760c').length;
        this.idleCount = this.vehicles.filter(v => v.color === '#f3c623').length;
        this.stoppedCount = this.vehicles.filter(v => v.color === '#ec0101').length;
        // this.inactiveCount = this.vehicles.filter(v => v.color === '#6c757d').length;
        // this.noDataCount = this.vehicles.filter(v => !v.lat || !v.lng).length;
        this.totalCount = this.vehicles.length;
        const avgLat = this.vehicles.reduce((sum, v) => sum + v.lat, 0) / this.vehicles.length;
        const avgLng = this.vehicles.reduce((sum, v) => sum + v.lng, 0) / this.vehicles.length;
        this.lat = avgLat;
        this.lng = avgLng;
        setTimeout(() => {
          this.fitMapToVehicles();
        }, 0)

      }
    });
  }

  filteredVehicles() {
    if (!this.searchText) return this.vehicles;
    return this.vehicles.filter(v =>
      v.vehicle_number.toLowerCase().includes(this.searchText.toLowerCase()) ||
      v.vehicle_name.toLowerCase().includes(this.searchText.toLowerCase()),
    );
  }

  selectVehicle(v: any) {
    this.selectedVehicle = v;
    // Zoom and center
    this.lat = v.lat;
    this.lng = v.lng;
    this.zoom = 14;

    // Show only this vehicle on map
    this.displayVehicles = [v];

    // Close other info windows
    this.infoWindows?.forEach(iw => iw.close());
  }
  closeSidebar() {
    this.selectedVehicle = null;
    this.displayVehicles = [...this.vehicles];
   this.zoom = 7;
  }

  logOut() {
    this.router.navigate(['/login']);
  }
  ngOnDestroy(): void {
    if (this.refreshSub) {
      this.refreshSub.unsubscribe();
    }
  }

  getDistanceProgress(vehicle: any): number {
    if (!vehicle?.last_trip_summary) return 0;

    const traveled = parseFloat(vehicle.last_trip_summary.odometer_travel_km) || 0;
    const maxDistance = 50; // adjust this according to your use case
    const progress = (traveled / maxDistance) * 100;

    return Math.min(Math.max(progress, 0), 100); // clamp between 0-100
  }


  getDurationProgress(vehicle: any): number {
    if (!vehicle?.last_trip_summary) return 0;

    // Parse duration_hms (HH:MM:SS) into seconds
    const durationHms = vehicle.last_trip_summary.duration_hms;
    if (!durationHms) return 0;

    const [h, m, s] = durationHms.split(':').map(Number);
    const currentDuration = h * 3600 + m * 60 + s;

    // If you want to calculate percentage, you need a max duration
    // Example: assume max trip duration = 8 hours (28800 seconds)
    const maxDuration = 8 * 3600;

    const progress = (currentDuration / maxDuration) * 100;
    return Math.min(Math.max(progress, 0), 100);
  }



  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  vehicleTypefilter(type: string) {
    // this.loading = true;
    const url = `${environment.apiBaseUrl}home_v2_public?mobile=${localStorage.getItem('MOBILE') || this.mobileNumber}&X-Api-Key=FEA3E5D0QFCEBFD54F0A6A674ECAE3F8&user_type=Customer&device_token=Web&vehicle_status_count=${type}`;
    this.http.get<any>(url).subscribe(res => {
      if (res.status && res.data.length > 0) {
        this.vehicleData = res.total_vehicles;
        this.vehicles = res.data.map((v: any) => {
          let icon = 'assets/images/all_images/table/yellow/Car.png'; // idle
          if (v.vehicle_motion_status_color === '#62760c') {
            icon = 'assets/images/all_images/table/green/Car.png'; // running
          } else if (v.vehicle_motion_status_color === '#ec0101') {
            icon = 'assets/images/all_images/table/red/Car.png'; // stopped
          }
          return {
            id: v.device_id,
            vehicle_number: v.vehicle_number,
            vehicle_type: v.vehicle_type,
            lat: parseFloat(v.latitude),
            lng: parseFloat(v.longitude),
            speed: v.speed,
            landmark: v.landmark,
            servertime: v.servertime,
            ignition: v.ignition,
            day_distance: v.day_distance,
            travel_duration: v.travel_duration,
            max_speed: v.max_speed,
            avg_speed: v.avg_speed,
            alert_count: v.alert_count,
            parking_duration: v.parking_duration,
            power_status: v.power_status,
            driver_name: v.driver_name,
            customer_name: v.customer_name,
            last_city: v.last_city,
            color: v.vehicle_motion_status_color,
            icon: icon,
            last_running_time: v.last_running_time,
            device_link_id: v.device_link_id,
            total_distance: v.total_distance,
            batteryLevel: v.batteryLevel,
            last_location: v.last_location,
            gps_lock_status: v.gps_lock_status,
            driver_mobile: v.driver_mobile,
            mmu_summary: v.mmu_summary,
            last_trip_summary: v.last_trip_summary,
            org_id: v.org_id,
            vehicle_name: v?.vehicle_name
          };
        });
        this.displayVehicles = [...this.vehicles];
        if (this.vehicles.length && this.mapInstance) {
          // this.fitMapToVehicles();
          const bounds = new google.maps.LatLngBounds();
          this.vehicles.forEach(v => {
            if (v.lat && v.lng) {
              bounds.extend(new google.maps.LatLng(v.lat, v.lng));
            }
          });
          this.mapInstance.fitBounds(bounds);
        }
      }
      this.loading = false;
    });
  }
  vehicleSpeedfilter(type: any) {
    const url = `${environment.apiBaseUrl}single_device_report_stats_v1_public?user_id=${localStorage.getItem('USER_ID')}&device_token=Web&user_type=Customer&device_link_id=${type.device_link_id}&report_date=2025-09-21&X-Api-Key=FEA3E5D0QFCEBFD54F0A6A674ECAE3F8&mobile=${localStorage.getItem('MOBILE') || this.mobileNumber}&org_id=${type.org_id}&vehicle_number=${type.vehicle_number}`;

    this.http.get<any>(url).subscribe({
      next: (res) => {
        if (res.status && res.data.length > 0) {
          this.vehicleSpeedData = res.data[0].today;
          this.last_trip_summary = res.data[0].last_trip_summary;
          this.mmu_summary = res.data[0].mmu_summary;
        } else {
        }
      },
      error: (err) => {
      },
    });

  }
  openFullscreen(elem: HTMLElement) {
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if ((elem as any).webkitRequestFullscreen) { // Safari
      (elem as any).webkitRequestFullscreen();
    } else if ((elem as any).msRequestFullscreen) { // IE11
      (elem as any).msRequestFullscreen();
    }
  }
  toggleFullscreen(elem: HTMLElement) {
    if (!document.fullscreenElement) {
      elem.requestFullscreen();
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    }
  }
  goHome() {
    this.router.navigate(['/web/dashboard']);
  }
  fitMapToVehicles() {
    if (!this.mapInstance || !this.vehicles.length) return;

    const bounds = new google.maps.LatLngBounds();

    this.vehicles.forEach(v => {
      if (!isNaN(v.lat) && !isNaN(v.lng)) {
        bounds.extend(new google.maps.LatLng(v.lat, v.lng));
      }
    });

    this.mapInstance.fitBounds(bounds);

    // Prevent excessive zoom when only one vehicle exists
    google.maps.event.addListenerOnce(this.mapInstance, 'bounds_changed', () => {
      if (this.mapInstance.getZoom()! > 15) {
        this.mapInstance.setZoom(15);
      }
    });
  }
}
